import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";
import qs from "qs"

const cmpAnalyticsFilterUrl = (route, filter) => {
  const {startDate, endDate, configurable, ...otherFilter} = filter
  let url

  if (configurable) {
    url = `/${configurable.type}s/${configurable.id}/cmp/analytics/${route}`
  } else {
    url = `/cmp/default/analytics/${route}`
  }
  const filterCopy = {date: {start_date: startDate, end_date: endDate} ,...otherFilter};
  for (const key in filterCopy) {
    if (!filterCopy[key]) {
      delete filterCopy[key];
    }
  }

  if (filterCopy) {
    url += `?${qs.stringify(filterCopy, { arrayFormat: 'brackets' })}`
  }
  return url
}

export const cmpAnalyticsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCmpAnalytics: builder.query({
      query: (filter) => {
        return {
          url: cmpAnalyticsFilterUrl("", filter)
        }},
      providesTags: (result = [], error, arg) => [{ type: 'CmpAnalytics', id: `${JSON.stringify(arg)}` } ],
    }),
    getCmpAnalyticsDataByDay: builder.query({
      query: (filter) => ({
        url: cmpAnalyticsFilterUrl("consents_by_day", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'CmpAnalytics', id: `data_by_day:${JSON.stringify(arg)}`  }],
    }),
    getCmpAnalyticsDataByPurpose: builder.query({
      query: (filter) => ({
        url: cmpAnalyticsFilterUrl("consent_rate_by_purpose", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'CmpAnalytics', id: `data_by_purpose:${JSON.stringify(arg)}`  }],
    }),
    getCmpAnalyticsDataByOs: builder.query({
      query: (filter) => ({
        url: cmpAnalyticsFilterUrl("consent_by_os", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'CmpAnalytics', id: `data_by_os:${JSON.stringify(arg)}`  }],
    }),
    getCmpAnalyticsConsentsOutput: builder.query({
      query: (filter) => ({
        url: cmpAnalyticsFilterUrl("consents_output", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'CmpAnalytics', id: `output:${JSON.stringify(arg)}`  }],
    }),
    getCmpAnalyticsDataByLang: builder.query({
      query: (filter) => ({
        url: cmpAnalyticsFilterUrl("consents_by_lang", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'CmpAnalytics', id: `data_by_lang:${JSON.stringify(arg)}`  }],
    }),
    getCmpAnalyticsRequestsByLang: builder.query({
      query: (filter) => ({
        url: cmpAnalyticsFilterUrl("consent_requests_by_lang", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'CmpAnalytics', id: `requests_by_lang:${JSON.stringify(arg)}`  }],
    }),
    getCmpAnalyticsDataByRank: builder.query({
      query: (filter) => ({
        url: cmpAnalyticsFilterUrl("consents_by_rank", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'CmpAnalytics', id: `data_by_rank:${JSON.stringify(arg)}`  }],
    }),
    getCmpAnalyticsRequestsByRank: builder.query({
      query: (filter) => ({
        url: cmpAnalyticsFilterUrl("consent_requests_by_rank", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'CmpAnalytics', id: `requests_by_rank:${JSON.stringify(arg)}`  }],
    }),
    getCmpAnalyticsByApp: builder.query({
      query: (filter) => ({
        url: cmpAnalyticsFilterUrl("apps_data", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'CmpAnalytics', id: `apps:${JSON.stringify(arg)}`  }],
    }),
    getCmpAnalyticsBySdk: builder.query({
      query: (filter) => ({
        url: cmpAnalyticsFilterUrl("sdk_data", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'CmpAnalytics', id: `sdk:${JSON.stringify(arg)}`  }],
    }),
    getCmpAnalyticsByLayout: builder.query({
      query: (filter) => ({
        url: cmpAnalyticsFilterUrl("layout_data", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'CmpAnalytics', id: `layout:${JSON.stringify(arg)}`  }],
    }),
    getCmpAnalyticsByLayoutByDay: builder.query({
      query: (filter) => ({
        url: cmpAnalyticsFilterUrl("consent_requests_by_layout_version_by_day", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'CmpAnalytics', id: `layout_day:${JSON.stringify(arg)}`  }],
    }),
    getCmpAnalyticsRequestsByLayout: builder.query({
      query: (filter) => ({
        url: cmpAnalyticsFilterUrl("consent_requests_by_layout_version", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'CmpAnalytics', id: `layout_requests:${JSON.stringify(arg)}`  }],
    }),
    getCmpAnalyticsByVendor: builder.query({
      query: (filter) => ({
        url: cmpAnalyticsFilterUrl("vendor_data", filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'CmpAnalytics', id: `vendor:${JSON.stringify(arg)}`  }],
    }),
  }),
  overrideExisting: false
})

export const {
  useGetCmpAnalyticsQuery,
  useGetCmpAnalyticsDataByDayQuery,
  useGetCmpAnalyticsDataByPurposeQuery,
  useGetCmpAnalyticsDataByOsQuery,
  useGetCmpAnalyticsConsentsOutputQuery,
  useGetCmpAnalyticsDataByLangQuery,
  useGetCmpAnalyticsRequestsByLangQuery,
  useGetCmpAnalyticsDataByRankQuery,
  useGetCmpAnalyticsRequestsByRankQuery,
  useGetCmpAnalyticsByAppQuery,
  useGetCmpAnalyticsBySdkQuery,
  useGetCmpAnalyticsByLayoutQuery,
  useGetCmpAnalyticsByLayoutByDayQuery,
  useGetCmpAnalyticsRequestsByLayoutQuery,
  useGetCmpAnalyticsByVendorQuery
} = cmpAnalyticsApiSlice
